import React from 'react';

const NotFound = () => {
    return (
        
             // not found part
        <div>
             <h1 className="text-info text-center p-5 mt-5">404!!!!Sorry!!!  Page Not Found!!</h1>
             <img className="w-100 h-100" src="https://yoast.com/app/uploads/2015/08/404_error_checking_FI.png" alt="" />
         </div>
    );
};

export default NotFound;